import _ from 'lodash';
import { createSelector } from 'reselect';

import { apiCriterionToPopoverCriterion } from './utils';
import {
  getComponentProps,
  getSavedSearchResults,
} from '../../form-designer/selectors/common.selectors';
import { getSavedSearchResultsKey } from '../../reducers/SavedSearchResultsReducer';

export const getResultsState = (state, { entityName, searchName, dataKey }) =>
  _.get(state, ['savedSearchResults', getSavedSearchResultsKey(entityName, searchName, dataKey)]);

export const getDefaultCriteria = createSelector([getResultsState], (resultsState) => {
  const advancedSearchCriteria = resultsState?.results?.advancedSearchCriteria ?? [];
  return advancedSearchCriteria.filter((criteria) => !('HasErrors' in criteria));
});

export const getDefaultCriteriaForPopover = createSelector([getDefaultCriteria], (criteria) =>
  criteria.map(apiCriterionToPopoverCriterion)
);

export const getViewName = (state, props) =>
  _.get(getResultsState(state, props), ['results', 'viewName']);

export const getTranslatedEntityName = (state, props) =>
  _.get(getResultsState(state, props), ['results', 'translatedEntityName'], '');
export const getTranslatedSearchName = (state, props) =>
  _.get(getResultsState(state, props), ['results', 'translatedSearchName'], '');

export const getSavedSearchResultsParams = createSelector(
  [getSavedSearchResults, getComponentProps],
  (savedSearchResults, { key }) => {
    return savedSearchResults[key]?.searchParams;
  }
);

export const getCurrentSavedSearchName = createSelector(
  [getSavedSearchResults],
  (savedSearchResults) => {
    return savedSearchResults?.currentSavedSearchName;
  }
);
